import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export type RouteKey =
  | "home"
  | "chargers"
  | "stationNew"
  | "stationRequest"
  | "stationDetail"
  | "favorites"
  | "login"
  | "authCallback"
  | "settings"
  | "howTo"
  | "privacy"
  | "activity"
  | "routePlanner"
  | "community"
  | "profile"
  | "adminVerify";

const NOINDEX: ReadonlySet<RouteKey> = new Set([
  "stationNew",
  "stationRequest",
  "favorites",
  "login",
  "authCallback",
  "settings",
  "adminVerify",
  // /home is the marketing landing — the canonical chargers root lives at /.
  // Without noindex it would compete with / in search rankings for the same
  // "VoltaRoute" / "cargadores Colombia" queries.
  "home",
]);

function setMeta(name: "description" | "robots", content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function RouteHead({ routeKey }: { routeKey: RouteKey }) {
  const { t } = useTranslation("seo");
  const title = t(`${routeKey}.title`);
  const description = t(`${routeKey}.description`);

  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("robots", NOINDEX.has(routeKey) ? "noindex,nofollow" : "index,follow");
  }, [routeKey, title, description]);

  return null;
}
